import React from 'react';
import { Row, Col } from 'antd';
import catloglogo from "../../../../assets/img/catloglogo.png";

const FirstPage = ({ catalogDetails, image }) => {
    return (
        <div style={styles.mainContainer}>
            {/* Header Section */}
            <div style={styles.headerContainer}>
                <Row align="middle" gutter={0}>
                    {/* Product Title Section */}
                    <Col span={13} style={styles.headerLeftSection}>
                        <div style={styles.titleContainer}>
                            <h1 style={styles.productTitle}>
                                {catalogDetails?.product_name}
                            </h1>
                        </div>
                    </Col>

                    {/* Product Image Section */}
                    <Col span={11} style={styles.headerRightSection}>
                        <div style={styles.imageContainer}>
                            <div style={styles.placeholderImage}>
                                {catalogDetails?.product_images &&
                                    <img src={`data:image/webp;charset=utf-8;base64,${image}`} alt="Cenvance" width="500px" height="500px" />
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* Description Section */}
            <div style={styles.descriptionContainer}>
                {/* Left Section with Logo */}
                <div style={styles.descriptionLeftSection}>
                    <img src={catloglogo} alt="Logo Icon" width={600} height={175} />
                </div>

                {/* Right Section with Description */}
                <div style={styles.descriptionRightSection}>
                    <div style={styles.descriptionTextContainer}>
                        <p style={styles.descriptionText}>
                            {catalogDetails?.description}
                        </p>
                    </div>
                </div>
            </div>

            {/* Footer Section */}
            <div style={styles.footerContainer}>
                <Row gutter={0} style={styles.footerRow}>
                    {/* Website URL Section */}
                    <Col span={12} style={styles.footerLeftSection}>
                        <div style={styles.urlContainer}>
                            <div style={styles.iconContainer}>
                                <div style={styles.globeIcon}>🌐</div>
                            </div>
                            <span style={styles.urlText}>https://www.cenvance.com</span>
                        </div>
                    </Col>

                    {/* Tagline Section */}
                    <Col span={12} style={styles.footerRightSection}>
                        <div style={styles.taglineContainer}>
                            <h3 style={styles.taglineText}>
                                Advanced Medical Equipments for<br />
                                Safety and Comfort
                            </h3>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

const styles = {
    mainContainer: {
        width: '100%',
        minHeight: '100vh', // Use viewport height
        fontFamily: 'Manrope, sans-serif',
        display: 'flex',
        flexDirection: 'column',
        padding: '10px',
    },
    headerContainer: {
        backgroundColor: '#ffffff',
        padding: '0',
        margin: '0',
        width: '100%',
        minHeight: '530px', // Changed to minHeight
        flex: '0 0 auto', // Don't grow, don't shrink
        fontFamily: 'Lexend, sans-serif',
        fontWeight: 700,
    },
    headerLeftSection: {
        backgroundColor: '#ffffff',
        padding: '0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
    headerRightSection: {
        height: '530px',
        width: '100%',
        backgroundColor: 'rgba(242, 242, 242, 1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    titleContainer: {
        width: '100%'
    },
    productTitle: {
        color: '#1a1a1a',
        fontSize: '52px',
        fontWeight: '700',
        lineHeight: '100%',
        margin: '0',
        textAlign: 'left',
        paddingLeft: '60px',
        paddingRight: '60px',
        letterSpacing: '3%',
        fontFamily: 'Lexend, sans-serif',
    },
    imageContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    placeholderImage: {
        alignItems: 'center',
        justifyContent: 'center',
    },

    // Description Styles
    descriptionContainer: {
        position: 'relative',
        width: '100%',
        minHeight: '440px', // Changed to minHeight
        flex: '1 0 auto', // Grow to fill space
        fontFamily: 'Manrope, sans-serif',
        overflow: 'hidden',
    },
    descriptionLeftSection: {
        position: 'absolute',
        left: '0',
        top: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(242, 242, 242, 1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        clipPath: 'polygon(0 0, 55% 0, 65% 100%, 0 100%)',
        zIndex: 1,
    },
    descriptionRightSection: {
        position: 'absolute',
        right: '0',
        top: '0',
        width: '60%',
        height: '100%',
        backgroundColor: '#0C3C78',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        paddingLeft: '35px',
        paddingRight: '10px',
        paddingTop: '20px',
        paddingBottom: '10px',
        clipPath: 'polygon(0 0, 100% 0, 100% 100%, 10% 100%)',
        zIndex: 2,
        lineHeight: "18px"
    },
    descriptionTextContainer: {
        paddingLeft: '24px',
        paddingRight: '10px',
        position: 'relative',
        overflow: 'hidden',
        transformOrigin: 'bottom left'
    },
    descriptionText: {
        color: 'white',
        fontSize: '16px',
        lineHeight: '1.5',
        margin: '0',
        textAlign: 'left',
    },

    // Footer Styles
    footerContainer: {
        width: '100%',
        fontFamily: 'Manrope, sans-serif',
        backgroundColor: 'transparent',
        flex: 'auto', // Don't grow, don't shrink
        marginTop: 'auto', // Push to bottom
    },
    footerRow: {
        margin: '0',
        minHeight: '80px'
    },
    footerLeftSection: {
        backgroundColor: '#f5f5f5',
        display: 'flex',
        alignItems: 'center',
        borderTop: '2px solid #ccc',
        padding: '20px'
    },
    footerRightSection: {
        backgroundColor: '#00ADEF',
        display: 'flex',
        alignItems: 'center',
        borderTop: '2px solid #ccc',
        padding: '20px'
    },
    urlContainer: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '30px',
        gap: '12px'
    },
    iconContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    globeIcon: {
        fontSize: '18px',
        color: '#666'
    },
    urlText: {
        color: '#5A667A',
        fontSize: '16px',
        fontWeight: '400',
        textDecoration: 'none'
    },
    taglineContainer: {
        paddingLeft: '30px',
        paddingRight: '30px'
    },
    taglineText: {
        color: 'white',
        fontSize: '20px',
        lineHeight: '1.3',
        margin: '0',
        letterSpacing: '0.3px',
        fontFamily: 'Lexend, sans-serif',
        fontWeight: 700,
    }
};

export default FirstPage;